import React, { useState, useEffect } from 'react';
import { Card, Col, Row } from 'react-bootstrap';
import AreaTableHeader from './AreaTableHeader';
import { BaseTableRQ } from 'components/common/models/BaseClass';
import { search } from 'services/skill-matric-services/smAreaService';
import PageHeader from 'components/common/PageHeader';
import AreaTable from './AreaTable';
import AreaModal from './AreaModal';

const SmAreadashboard = () => {
  const defaultRQ = { ...new BaseTableRQ(1, 5) };
  const [areas, setAreas] = useState([]);
  const [total, setTotal] = useState(0);
  const [paging, setPaging] = useState({ ...defaultRQ });
  const [isFilter, setIsFilter] = useState(false);
  const [isModal, setIsModal] = useState(false);
  const [dataModal, setDataModal] = useState({});

  useEffect(() => {
    setIsFilter(false);
  }, []);

  const gotoPage = index => {
    index += 1;
    if (index <= 0) return;
    paging.pageNum = index;
    loadAreas(paging);
  };

  const toggelFilter = () => {
    setIsFilter(!isFilter);
  };
  const toggelModal = () => {
    setIsModal(!isModal);
  };

  const nextPage = () => {
    const page = paging.pageNum + 1;
    if (page > Math.ceil(total / paging.pageSize)) return;
    paging.pageNum = page;
    loadAreas(paging);
  };

  const previousPage = () => {
    const page = paging.pageNum - 1;
    if (page <= 0) return;
    paging.pageNum = page;
    loadAreas(paging);
  };

  const handleCloseModal = () => {
    setIsModal(false);
    setDataModal({});
  };
  const handleSubmitModal = () => {
    handleCloseModal();
    loadAreas(defaultRQ);
  };

  useEffect(() => {
    loadAreas(defaultRQ);
  }, []);

  const loadAreas = pagingRq => {
    search(pagingRq)
      .then(res => {
        if (res) {
          setAreas(res.items);
          setTotal(res.total);
        }
      })
      .catch(err => {
        console.log(err);
      });
    setPaging(pagingRq);
  };

  const handleSeach = keyword => {
    loadAreas({ ...defaultRQ, keyword });
  };

  return (
    <>
      <PageHeader
        title="Area"
        description={`Manage and view all available Areas from this page.`}
        className="mb-3"
      ></PageHeader>
      <Row className="g-3 mb-3">
        <Col lg={12}>
          <Card>
            <Row style={{ padding: '10px' }}>
              <AreaTableHeader
                toggelFilter={() => toggelFilter()}
                toggelModal={() => toggelModal()}
                handleSearch={handleSeach}
                style={{ padding: '10px' }}
              />
              <Col lg={isFilter ? 9 : 12}>
                <AreaTable
                  data={areas}
                  paging={paging}
                  total={total}
                  nextPage={nextPage}
                  previousPage={previousPage}
                  gotoPage={gotoPage}
                  handleClickRow={(e, row) => {
                    if (row) {
                      setDataModal(row.original);
                      setIsModal(true);
                    }
                  }}
                />
              </Col>
              {/* 
              {isFilter && (
                <Col lg={3}>
                  <ActionPlanFilter
                    handleChange={handleChange}
                    formData={filter}
                    handleSubmit={handleSubmit}
                  />
                </Col>
              )} */}
            </Row>
          </Card>
        </Col>
      </Row>
      <AreaModal
        isShow={isModal}
        handleClose={handleCloseModal}
        data={dataModal}
        handleSubmit={handleSubmitModal}
      />
    </>
  );
};

SmAreadashboard.propTypes = {};

export default SmAreadashboard;
